/* 
Site global JS, as a rule of thumb, 
this should only contain JS that is 
needed for the majority of pages on the site.
*/
import "./resource_v1";

(function ($) {
  // vanilla JavaScript external links in new tab.
  var externalLinksNewTab = function () {
    var links = document.links;

    for (var i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname != window.location.hostname) {
        links[i].target = "_blank";
      } else if (links[i].href.indexOf(".pdf") != -1) {
        links[i].target = "_blank";
      }
    }
  };

  $(document).ready(function () {
    // here we go
    externalLinksNewTab();
    $("a#closeit").click(function () {
      $(".announcement-wrap").addClass("hide");
      return false;
    });
    const firstPage = document.querySelector('.gform_page:first-child .gform_next_button');
if (firstPage) firstPage.value = 'Begin';
  });
})(jQuery);

import "./nav";
